import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    royaltyPlanFeeTemplate: null,
    royaltyPlanFeeTemplates: null,
    isNew: false,
    lastState: null,
    lastScope: null,
};

const royaltyPlanFeeTemplateReducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.ROYALTYPLANFEETEMPLATE_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.ROYALTYPLANFEETEMPLATE_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.ROYALTYPLANFEETEMPLATE_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        case actionTypes.ROYALTYPLANFEETEMPLATE_LISTRESET: {
            return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
        }
        default: {
            return state;
        }
    }
};

export default royaltyPlanFeeTemplateReducer;
